import Vue from "vue";

Vue.config.productionTip = false;

import "./components/Core";
